import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { environment } from 'src/environments/environment';
import { City } from 'src/app/core/interfaces/city';
import { BasicCity } from 'src/app/core/interfaces/basicCity';
import { Observable } from 'rxjs';
import { ApiResponseTax } from 'src/app/core/interfaces/tax';
import { Utils } from 'src/app/core/resources/utils';


@Injectable({
    providedIn: 'root'
})
export class CityService {
    /**
     * Última empresa de transporte elegida en Ciudades (listado o detalle). El
     * listado la prioriza sobre la URL para que, al volver de un detalle donde se
     * cambió de empresa (con "Volver" o el atrás del navegador), muestre la misma.
     */
    public lastTransportCompanyId: string = null;

    constructor(
        private http: HttpClient,
        private endpointResources: Endpoints,
        private utils: Utils
    ) {

    }

    public updateMainCity(city, transportNit?: string) {
        return this.http.post(
            environment.urlServerTeclogi + this.endpointResources.updateMainCity, city,
            { observe: "response", params: this.transportNitParams(transportNit) }
        )
    }

    public updateIndependentCity(city, transportNit?: string) {
        return this.http.put(
            environment.urlServerTeclogi + this.endpointResources.urlUpdateIndependentCity, city,
            { params: this.transportNitParams(transportNit) }
        )
    }

    public createCity(city) {
        return this.http.post(
            environment.urlServerTeclogi + this.endpointResources.cities, city
        )
    }

    /** city: { mainCity, subCities }. La ciudad principal va en la ruta; el cuerpo solo lleva las subciudades. */
    public addSubcities(city, transportNit?: string) {
        const mainCityId = city && city.mainCity ? city.mainCity.id : null;
        return this.http.post(
            environment.urlServerTeclogi + this.endpointResources.cities + "/" + mainCityId + this.endpointResources.citySubcities,
            { subCities: city && city.subCities ? city.subCities : [] },
            { params: this.transportNitParams(transportNit) }
        )
    }

    public getAllCities(pageKey?: number, pageSize?: number, transportNit?: string) {
        let params = new HttpParams()
        if (this.utils.isDefined(pageKey)) params = params.append('pageKey', String(pageKey));
        if (this.utils.isDefined(pageSize)) params = params.append('pageSize', String(pageSize));
        if (transportNit) params = params.append('transportCompanyId', transportNit);
        return this.http.get(
            environment.urlServerTeclogi + this.endpointResources.cities, { params }
        );
    }

    public getTaxes(transportCompanyId?: string): Observable<ApiResponseTax> {
        return this.http.get<ApiResponseTax>(
            environment.urlServerTeclogi + this.endpointResources.companyTaxes,
            { params: this.transportNitParams(transportCompanyId) }
        );
    }

    public getProductSiigo(pageKey: number, pageSize: number, transportCompanyId?: string): Observable<any> {
        const params = this.transportNitParams(transportCompanyId)
            .set('pageKey', String(pageKey))
            .set('pageSize', String(pageSize));

        return this.http.get(environment.urlServerTeclogi + this.endpointResources.companyProductSiigo, { params });
    }

    public getSubcityByIdCity(cityId: string, transportNit?: string): Observable<City[]> {
        return this.http.get<City[]>(
            environment.urlServerTeclogi + this.endpointResources.cities + "/" + cityId + this.endpointResources.citySubcities,
            { params: this.transportNitParams(transportNit) }
        );
    }

    /** Desasocia la subciudad de su ciudad principal. */
    public removeSubCity(idSubcity, transportNit?: string) {
        return this.http.delete(
            environment.urlServerTeclogi + this.endpointResources.cities + "/" + idSubcity + this.endpointResources.cityMainCity,
            { params: this.transportNitParams(transportNit) }
        );
    }

    public getCityById(id, transportNit?: string) {
        return this.http.get(
            environment.urlServerTeclogi + this.endpointResources.cities + "/" + id,
            { params: this.transportNitParams(transportNit) }
        );
    }

    /** Query param de la empresa de transporte; vacío cuando no hay (comportamiento previo). */
    private transportNitParams(transportNit?: string): HttpParams {
        let params = new HttpParams();
        if (transportNit) params = params.append('transportCompanyId', transportNit);
        return params;
    }

    public putICACity(city) {
        return this.http.put(
            environment.urlServerTeclogi + this.endpointResources.cities + this.endpointResources.urlUpdatecities, city
        )
    }

    public getReteicaCity(city: City | BasicCity): number {
        let reteica: number = 0;
        if (city && city['mainCity'] && city['mainCity'].reteica > 0) {
            reteica = city['mainCity'].reteica;
        } else if (city && city['reteica'] > 0) {
            reteica = city['reteica'];
        }
        return reteica;
    }

    public getCityValue(city: City, value: string) {
        if (city && city[value]) return city[value];
        else if (city && city.mainCity && city.mainCity[value]) return city.mainCity[value];
        return undefined;
    }
}
